import angular from 'angular';

export class FlowinglyDragDrop {
  public link: (
    scope: ng.IScope,
    element: ng.IAugmentedJQuery,
    attrs: ng.IAttributes
  ) => void;
  public restrict: string;
  public scope = {
    isDraggable: '<',
    isDroppable: '<',
    dragStart: '&',
    dragEnd: '&',
    dragOver: '&',
    dragLeave: '&',
    drop: '&'
  };

  constructor() {
    this.link = (scope: ng.IScope, element: JQuery) => {
      if ((scope as any).isDraggable) {
        element.attr('draggable', 'true');
      }

      element.on('dragstart', function (ev) {
        ev.originalEvent.dataTransfer.effectAllowed = 'copy';
        (scope as any).dragStart();
      });

      element.on('dragend', function () {
        (scope as any).dragEnd();
      });

      if ((scope as any).isDroppable) {
        element.on('dragover', function (ev) {
          ev.preventDefault();
          ev.originalEvent.dataTransfer.dropEffect = 'copy';
          (scope as any).dragOver();
        });

        element.on('dragleave', function (ev) {
          ev.preventDefault();
          (scope as any).dragLeave();
        });

        element.on('drop', function (ev) {
          ev.preventDefault();
          (scope as any).drop();
        });
      }
    };

    this.restrict = 'A';
  }

  static Factory() {
    const directive = () => {
      return new FlowinglyDragDrop();
    };

    directive['$inject'] = [];

    return directive;
  }
}

angular
  .module('flowingly.directives')
  .directive('flowinglyDragDrop', FlowinglyDragDrop.Factory());
